import 추천_PC from "/public/assets/pc/images/pic/img_linkedin_4_1.svg";
import 상품권받기1_PC from "/public/assets/pc/images/pic/img_linkedin_4_2.svg";
import 카카오공유_PC from "/public/assets/pc/images/pic/img_linkedin_kakao.png";
import 링크공유_PC from "/public/assets/pc/images/pic/img_linkedin_link.png";

import 추천_Mobile from "/public/assets/mobile/images/pic/img_linkedin_4_1.svg";
import 상품권받기1_Mobile from "/public/assets/mobile/images/pic/img_linkedin_4_2.svg";
import 카카오공유_Mobile from "/public/assets/mobile/images/pic/img_linkedin_kakao.png";
import 링크공유_Mobile from "/public/assets/mobile/images/pic/img_linkedin_link.png";
import type { StaticImageData } from "next/image";

export type 이벤트기본정보 = {
  바탕색: string;
  높이: string;
  이름: string;
  이미지: StaticImageData;
};

export const 공유_PC: StaticImageData[] = [
  카카오공유_PC,
  링크공유_PC
];

export const 공유_Mobile: StaticImageData[] = [
  카카오공유_Mobile,
  링크공유_Mobile
];

export const 추천이벤트_목록_PC: 이벤트기본정보[] = [
  {
    바탕색: "#5A30F9",
    높이: "1086px",
    이미지: 추천_PC,
    이름: "추천",
  }, 
  {
    바탕색: "#270776",
    높이: "613px",
    이미지: 상품권받기1_PC,
    이름: "상품권받기1",
  },

];

export const 추천이벤트_목록_Mobile: 이벤트기본정보[] = [
  {
    바탕색: "#5A30F9",
    높이: "580px",
    이미지: 추천_Mobile,
    이름: "추천",
  }, 
  {
    바탕색: "#270776",
    높이: "370px",
    이미지: 상품권받기1_Mobile,
    이름: "상품권받기1",
  },
     
];